// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE cf-component-icon/src/svgtoreact.sh TO MODIFY

import React from 'react';
import PropTypes from 'prop-types';

var User = function User(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return React.createElement(
    'svg',
    {
      className: className,
      'aria-label': label,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 16 16'
    },
    React.createElement('path', { d: 'M8.013.747A7.253 7.253 0 1 0 15.266 8 7.253 7.253 0 0 0 8.013.747zm0 2.385a2.776 2.776 0 0 1 2.622 2.908 2.776 2.776 0 0 1-2.622 2.908A2.776 2.776 0 0 1 5.391 6.04a2.776 2.776 0 0 1 2.622-2.909zm4.253 9.2a6.049 6.049 0 0 1-8.506 0v-.354a2.686 2.686 0 0 1 1.748-2.456.807.807 0 0 1 .52 0 7.744 7.744 0 0 0 1.984.223A7.743 7.743 0 0 0 10 9.518a.807.807 0 0 1 .52 0 2.686 2.686 0 0 1 1.749 2.457z' })
  );
};

User.propTypes = {
  className: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default User;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/User.js
// module id = 1067
// module chunks = 1